var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-cell",class:{
        'placeholder-cell': _vm.isPlaceholder,
        'text-right': _vm.align === 'right',
        'text-center': _vm.align === 'center'
    },style:(_vm.cellStyle),on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isPlaceholder)?_c('div',{staticClass:"cell-content"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2):_c('div',{staticClass:"placeholder-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }